import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "d-flex flex-fill align-items-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "flex-column" }, [
    /*#__PURE__*/_createVNode("h5", { class: "mb-0 me-2" }, "Tildel rolle på vegne af")
  ])
], -1)
const _hoisted_2 = { class: "flex flex-column" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { class: "control-label required" }, " Profil e-mail ", -1)
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Søger efter profil... ")
const _hoisted_7 = {
  key: 1,
  class: "control-label",
  style: {"margin-left":"8px","margin-top":"8px"}
}
const _hoisted_8 = {
  key: 2,
  class: "mt-3",
  style: {"border":"1px solid #d5d7db","margin-left":"unset","border-radius":"8px"}
}
const _hoisted_9 = { style: {"margin-top":"0.5rem","margin-bottom":"0.5rem","margin-left":"1rem","margin-right":"1rem"} }
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = {
  class: "text-muted",
  style: {"margin-bottom":"0.5rem"}
}
const _hoisted_12 = {
  key: 3,
  class: "control-label mt-3",
  style: {"margin-top":"8px"}
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "text-muted" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 5,
  class: "mt-5 p-5 bg-info flex-grow-1"
}
const _hoisted_17 = { class: "d-flex align-items-start mb-2" }
const _hoisted_18 = /*#__PURE__*/_createVNode("h2", null, "Roller", -1)
const _hoisted_19 = { class: "ms-auto d-flex gap-2" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" + Tilføj rolleprofil ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" + Tilføj rolle ")
const _hoisted_22 = { class: "d-flex flex-column" }
const _hoisted_23 = { class: "text-muted" }
const _hoisted_24 = { class: "text-muted" }
const _hoisted_25 = { class: "appension" }
const _hoisted_26 = { class: "d-flex justify-content-end" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Ok")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_FormErrors = _resolveComponent("FormErrors")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_error = _resolveComponent("error")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_RoleOnBehalfOfPicker = _resolveComponent("RoleOnBehalfOfPicker")!
  const _component_UserRoleProfilePicker = _resolveComponent("UserRoleProfilePicker")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Dialog, {
      modal: "",
      visible: _ctx.isVisible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isVisible = $event)),
      draggable: false,
      class: "appension assign-role-obo-modal",
      style: { width: '50rem' },
      closable: false
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createVNode("div", _hoisted_25, [
          _createVNode("div", _hoisted_26, [
            _createVNode(_component_Button, {
              onClick: _ctx.hide,
              class: "link me-2"
            }, {
              default: _withCtx(() => [
                _hoisted_27
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_o_field, {
              variant: _ctx.v$.emailField.$error ? 'danger' : ''
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_input, {
                  modelValue: _ctx.emailField,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.emailField = $event)),
                  class: { invalid: _ctx.v$.emailField.$error },
                  placeholder: "Indtast profil e-mail",
                  onInput: _ctx.handleInput
                }, null, 8, ["modelValue", "class", "onInput"])
              ]),
              _: 1
            }, 8, ["variant"])
          ]),
          _createVNode(_component_FormErrors, {
            errors: _ctx.v$.emailField.$errors
          }, null, 8, ["errors"]),
          (_ctx.loadingGetUserOfEmail)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode(_component_font_awesome_icon, {
                  class: "me-2",
                  spin: "",
                  icon: ['fas', 'spinner']
                }),
                _hoisted_6
              ]))
            : _createCommentVNode("", true),
          (_ctx.usersByEmail && _ctx.usersByEmail.length === 0)
            ? (_openBlock(), _createBlock("label", _hoisted_7, " Ingen profil fundet med denne e-mail. "))
            : _createCommentVNode("", true),
          (_ctx.usersByEmail && _ctx.usersByEmail.length === 1)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("b", null, _toDisplayString(_ctx.selectedUser.organization.vat) + " - " + _toDisplayString(_ctx.selectedUser.organization.name), 1),
                  _hoisted_10,
                  _createVNode("span", _hoisted_11, _toDisplayString(_ctx.selectedUser.firstname) + " " + _toDisplayString(_ctx.selectedUser.lastname), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.usersByEmail && _ctx.usersByEmail.length > 1)
            ? (_openBlock(), _createBlock("label", _hoisted_12, " Vælg en profil "))
            : _createCommentVNode("", true),
          (_ctx.usersByEmail && _ctx.usersByEmail.length > 1)
            ? (_openBlock(), _createBlock(_component_Dropdown, {
                key: 4,
                modelValue: _ctx.selectedUser,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedUser = $event)),
                options: _ctx.usersByEmail,
                optionLabel: "email",
                placeholder: "Vælg en profil...",
                onChange: _ctx.onUserSelected,
                class: "mt-3 w-100 user-dropdown"
              }, {
                value: _withCtx((slotProps) => [
                  (slotProps.value)
                    ? (_openBlock(), _createBlock("div", _hoisted_13, [
                        _createVNode("div", null, [
                          _createVNode("b", null, _toDisplayString(slotProps.value.organization.vat) + " - " + _toDisplayString(slotProps.value.organization.name), 1)
                        ]),
                        _createVNode("span", _hoisted_14, _toDisplayString(slotProps.value.firstname) + " " + _toDisplayString(slotProps.value.lastname), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                option: _withCtx((slotProps) => [
                  _createVNode("div", null, [
                    _createVNode("div", null, [
                      _createVNode("b", null, _toDisplayString(slotProps.option.organization.vat) + " - " + _toDisplayString(slotProps.option.organization.name), 1)
                    ]),
                    (slotProps.option.organization)
                      ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(slotProps.option.firstname) + " " + _toDisplayString(slotProps.option.lastname), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options", "onChange"]))
            : _createCommentVNode("", true),
          (_ctx.userIdAssigningRole)
            ? (_openBlock(), _createBlock("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode("div", _hoisted_19, [
                    _createVNode(_component_Button, {
                      disabled: _ctx.addRemoveLoading,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.userRoleProfilePicker?.toggle($event))),
                      class: "secondary"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.addRemoveLoading)
                          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              key: 0,
                              class: "me-2",
                              spin: "",
                              icon: ['fas', 'spinner']
                            }))
                          : _createCommentVNode("", true),
                        _hoisted_20
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_Button, {
                      disabled: _ctx.addRemoveLoading,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.roleOnBehalfOfPickerPicker?.toggle($event))),
                      class: "secondary"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.addRemoveLoading)
                          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              key: 0,
                              class: "me-2",
                              spin: "",
                              icon: ['fas', 'spinner']
                            }))
                          : _createCommentVNode("", true),
                        _hoisted_21
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ]),
                _createVNode(_component_DataTable, {
                  stripedRows: true,
                  sortOrder: 1,
                  responsiveLayout: "scroll",
                  value: _ctx.userAssigningRole?.roles,
                  class: "text-start",
                  selectionMode: "single"
                }, {
                  empty: _withCtx(() => [
                    _createVNode(_component_error, { error: {
                  title: 'Ingen roller',
                  message: 'Der er ikke nogle roller tilknyttet profilen endnu',
                } })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "name",
                      sortable: true
                    }, {
                      body: _withCtx(({ data }) => [
                        _createVNode("div", _hoisted_22, [
                          _createVNode("small", _hoisted_23, _toDisplayString(data.organizationName), 1),
                          _createVNode("small", _hoisted_24, _toDisplayString("Applikation: " + data.applicationName), 1),
                          _createTextVNode(" " + _toDisplayString(data.roleName), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      style: {"width":"1px","white-space":"nowrap"},
                      field: "menu"
                    }, {
                      body: _withCtx(({ data }) => [
                        _createVNode(_component_Button, {
                          class: "danger inverted",
                          onClick: ($event: any) => (_ctx.onRemovedRole(data))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'minus'] })
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_RoleOnBehalfOfPicker, {
      disabled: _ctx.addRemoveLoading,
      ref: "roleOnBehalfOfPickerPicker",
      addedRoles: _ctx.userAssigningRole.roles as _ctx.UserRoleType[] ?? [],
      onAddedRole: _ctx.onAddedRole,
      assigneeRoles: 
        (_ctx.organization?.assigneeRoles ?? []).filter((role) => role !== null)
      
    }, null, 8, ["disabled", "addedRoles", "onAddedRole", "assigneeRoles"]),
    _createVNode(_component_UserRoleProfilePicker, {
      disabled: _ctx.addRemoveLoading,
      ref: "userRoleProfilePicker",
      assigneeRoles: 
        (_ctx.organization?.assigneeRoles ?? []).filter((role) => role !== null)
      ,
      onProfilesSelected: _ctx.onProfilesSelected
    }, null, 8, ["disabled", "assigneeRoles", "onProfilesSelected"])
  ]))
}